"use client";
import { useDebounce } from "@/hooks/useDebounce";
import { useTranslations } from "@/i18n/client";
import { useSearchParams } from "next/navigation";
import { useSearchQuery } from "./hooks/useProductSearch";
import styles from "./index.module.css";

interface Props {}

export const SearchTitle = ({}: Props) => {
  const search = useSearchParams().get("q") || "";
  const [query] = useSearchQuery(search);
  const debounced = useDebounce(query, 150);
  const t = useTranslations("search");

  return (
    <h1 className={styles.title}>{debounced ? t("searchResultsTitle") : ""}</h1>
  );
};
